import { Mask } from 'antd-mobile'
import React, { useState } from 'react'
import './css/IncomeAlert.css'
export default function IncomeAlert(props) {

  const [visible, setVisible] = useState(true)

  return (
    <div className='income-alert-index'>
      <Mask visible={visible} onMaskClick={() => setVisible(false)}>
        <div className='income-alert-container'>
          <div className={"content " + (props.numbers == true ? 'numbers' : '')} style={{backgroundImage:'url(resources/251222/sign_alert_bg.png)',backgroundSize:'100% 100%'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
              <img src="resources/251222/laba.png" alt="" height={95}/>
            </div>
            <p>{props.render()}</p>
            <img className='done' src="resources/250410/done.png" alt="" height={49} onClick={()=>{
              if (props.close){
                props.close()
              }
            }}/>
          </div>
          <div className="close" onClick={()=>{
            if (props.close){
              props.close()
            }
          }}>
            <img src="resources/250410/close.png" alt="" height={22}/>
          </div>
        </div>
      </Mask>
    </div>
  )
}
